import styled from 'styled-components';
import { ImageUploader } from '@landlord-tech/ui-kit-opp/dist/components/ImageUploader';

export const SImageUploader = styled(ImageUploader)`
  &&& {
  }
`;
